class TestimonialCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.testimonial-carousel__track');
    this.cards = [...this.querySelectorAll('.testimonial-card')];
    this.dots = [...this.querySelectorAll('.testimonial-carousel__dot')];
    this.prevButton = this.querySelector('.testimonial-carousel__arrow--prev');
    this.nextButton = this.querySelector('.testimonial-carousel__arrow--next');

    if (!this.track || this.cards.length === 0) return;

    this.activeIndex = 0;

    this.prevButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1));

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goTo(index));
    });

    this.updateControls();
  }

  /**
   * Index-based navigation driven by transform: translateX(), not scroll
   * position. Wraps at both ends so next/prev always has a valid target.
   * The target offset is each card's own offsetLeft within the track
   * (the track is position: relative, so this is exact regardless of the
   * staggered overlap margins) — this works identically whether the
   * card row ends up wider or narrower than its viewport, since it
   * never depends on scrollWidth/clientWidth or overflow existing.
   */
  goTo(index) {
    const count = this.cards.length;
    this.activeIndex = ((index % count) + count) % count;

    const target = this.cards[this.activeIndex];
    this.track.style.transform = `translateX(-${target.offsetLeft}px)`;

    this.updateControls();
  }

  updateControls() {
    this.dots.forEach((dot, index) => {
      const isActive = index === this.activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    this.cards.forEach((card, index) => {
      card.classList.toggle('is-active', index === this.activeIndex);
    });
  }
}

if (!customElements.get('testimonial-carousel')) {
  customElements.define('testimonial-carousel', TestimonialCarousel);
}
